<app-page-content [enableMenuButton]="true">
  <span pagetitle>Oversikt</span>

  <div pagecontent style="display: flex; flex-direction: column">
    <app-expand-panel title="Sist oppdaterte sendinger">
      <app-shipment-list *ngIf="!coreConfiguration.isMobile"[headersVisible]="false" [showStatusColumn]="true" [shipments]="shipments"></app-shipment-list>

      <app-list *ngIf="coreConfiguration.isMobile" maxCount="6" [totalCount]="5">
        <app-shipment-item *ngFor="let item of shipments" [shipment]="item"
                           (click)="showShipment(item)"></app-shipment-item>
      </app-list>
    </app-expand-panel>
    <app-expand-panel title="Siste sendinger med avvik" style="margin-top: 3em">
      <app-shipment-list *ngIf="!coreConfiguration.isMobile" [headersVisible]="false" [showDeviationColumn]="true"
                         [shipments]="deviatedShipments"></app-shipment-list>

      <app-list *ngIf="coreConfiguration.isMobile" maxCount="6" [totalCount]="5">
        <app-shipment-item *ngFor="let item of deviatedShipments" [shipment]="item"
                           (click)="showShipment(item)"></app-shipment-item>
      </app-list>
    </app-expand-panel>
  </div>
</app-page-content>
